import { render, staticRenderFns } from "./trainSignDetail.vue?vue&type=template&id=48d30db9"
import script from "./trainSignDetail.vue?vue&type=script&lang=js"
export * from "./trainSignDetail.vue?vue&type=script&lang=js"
import style0 from "./trainSignDetail.vue?vue&type=style&index=0&id=48d30db9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports